














import { locale } from "moment";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { DeductibleTypeEnum } from './Passenger/models/TransportationPermission';

@Component({
  components: {
  },
})
export default class DeductibleTypeSelect extends Vue {
  selectedDeductibleType: DeductibleTypeEnum;

  deductibleOptions = [
    {
        text: this.$i18n.translate('transportationPermission.deductibleType.noDeductible', 'No excess'),
        value: DeductibleTypeEnum.NoDeductible,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.static', 'Kiinteä / matka'),
        value: DeductibleTypeEnum.Static,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.fixedMonthly', 'Kiinteä / kk'),
        value: DeductibleTypeEnum.FixedMonthly,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.matkahuolto', 'Matkahuolto'),
        value: DeductibleTypeEnum.Matkahuolto,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.walttiHame', 'WalttiHäme'),
        value: DeductibleTypeEnum.WalttiHäme,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.riihimaki', 'Riihimäki'),
        value: DeductibleTypeEnum.Riihimäki,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.nysse', 'Nysse'),
        value: DeductibleTypeEnum.Nysse,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.euraMatkahuolto', 'Eura Matkahuolto'),
        value: DeductibleTypeEnum.EuraMatkahuolto,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.kessoteMatkahuolto', 'Kessote Matkahuolto'),
        value: DeductibleTypeEnum.KessoteMatkahuolto,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.raumaMatkahuolto', 'Rauma Matkahuolto'),
        value: DeductibleTypeEnum.RaumaMatkahuolto,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.poriMatkahuolto', 'Pori Matkahuolto'),
        value: DeductibleTypeEnum.PoriMatkahuolto,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.hslTwoZoneMonthly', 'HSL 2 alueen kuukausilippu'),
        value: DeductibleTypeEnum.HslTwoZoneMonthly,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.askolaAsiointi', 'Askola Asiointi'),
        value: DeductibleTypeEnum.AskolaAsiointi,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.askolaTyo', 'Askola Työ'),
        value: DeductibleTypeEnum.AskolaTyo,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.askolaKoulu', 'Askola Koulu'),
        value: DeductibleTypeEnum.AskolaOpiskelu,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.loviisa', 'Loviisa'),
        value: DeductibleTypeEnum.Loviisa,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.porvooAsiointi', 'Porvoo Asiointi'),
        value: DeductibleTypeEnum.PorvooAsiointi,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.porvooTyo', 'Porvoo Työ'),
        value: DeductibleTypeEnum.PorvooTyo,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.porvooOpiskelu', 'Porvoo Opiskelu'),
        value: DeductibleTypeEnum.PorvooOpiskelu,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.porvooSHL', 'Porvoo SHL'),
        value: DeductibleTypeEnum.PorvooSHL,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.sipooAsiointi', 'Sipoo Asiointi'),
        value: DeductibleTypeEnum.SipooAsiointi,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.sipooTyo', 'Sipoo Työ'),
        value: DeductibleTypeEnum.SipooTyo,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.sipooSHL', 'Sipoo SHL'),
        value: DeductibleTypeEnum.SipooSHL,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.hslStudentMonthly', 'HSL monthly ticket (student)'),
        value: DeductibleTypeEnum.HslStudentMonthly,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.sipooOpiskelu', 'Sipoo Opiskelu'),
        value: DeductibleTypeEnum.SipooOpiskelu,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.walttiJKL', 'Waltti(Jyväskylä)'),
        value: DeductibleTypeEnum.WalttiJKL,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.vpl', 'Vpl'),
        value: DeductibleTypeEnum.Vpl,
      },
      {
        text: this.$i18n.translate('transportationPermission.deductibleType.keusoteMatkahuolto', 'Keusote Matkahuolto'),
        value: DeductibleTypeEnum.KeusoteMatkahuolto,
      },
  ];

  defaultDeductibleTypes = [ 
    DeductibleTypeEnum.NoDeductible,
    DeductibleTypeEnum.Static,
    DeductibleTypeEnum.FixedMonthly
  ];

  @Prop({ required: true }) value: DeductibleTypeEnum | null;
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: ''}) hint: string;
  @Prop({ default: ''}) persistentHint: string;

  @Watch('value', { immediate: true }) onValueChanged() {
    if (this.value === null || this.value === undefined) {
      return this.selectDeductibleType(DeductibleTypeEnum.NoDeductible);
    }
    this.selectedDeductibleType = this.value;
  }

  get organizationId() {
    let organizationId = '';
    if (this.$route.params.organizationId) {
      organizationId = this.$route.params.organizationId;
    } else if (this.$route.params.passengerId) {
      organizationId = this.$store.getters['passenger/passengerOrganizationId'](this.$route.params.passengerId);
    }
    return organizationId || null;
  }

  get deductibleTypeOptions() {
    let types = this.defaultDeductibleTypes;

    if (this.organizationId) {
      // tslint:disable-next-line
      const deductibleTypeIds: string = this.$store.getters['organization/organizationPtpDeductibleTypeIds'](this.organizationId);
      const deductibleTypes = deductibleTypeIds.split(',').filter(x => x).map(id => parseInt(id, 10));
      types = deductibleTypes.filter(x => !isNaN(x));
    }
    const options = types
    .map(t => this.deductibleOptions.find(dt => dt.value === t))
    .filter(x => x);

    return options.sort((a, b) => a.text.localeCompare(b.text));
  }

  selectDeductibleType(deductibleType: DeductibleTypeEnum) {
    this.selectedDeductibleType = deductibleType;
    this.$emit('input', this.selectedDeductibleType);
  }

}
